import Branch from 'branch-sdk'
import Config from 'APP/Config'
import { END, type END as ENDType } from 'redux-saga'
import { logger } from 'APP/Lib/Datadog'

type BranchEvent = { error: unknown } | { params: Record<string, unknown> | undefined }
type BranchEmitter = (event: BranchEvent | ENDType) => void

const BranchEventChannel = (emmiter: BranchEmitter): (() => void) => {
  Branch.init(Config.BRANCH_KEY, (err, data) => {
    // Branch.init can invoke this callback synchronously (e.g. a cached session on the same-tab
    // reload after the Auth0 redirect). Defer emission via setTimeout so the saga's yield take()
    // has a chance to register a taker — redux-saga's default buffers.none() silently drops
    // events emitted before a taker is registered.
    setTimeout(() => {
      // If this page load is an Auth0 error redirect (any OAuth error code, e.g.
      // login_required, access_denied when the member cancels at the IdP), stop
      // processing — the SSO flow failed and we should land on the WelcomeScreen.
      const hashParams = new URLSearchParams((window?.location?.hash || '').replace(/^#/, ''))
      const authError = hashParams.get('error')

      if (authError) {
        // Failed/cancelled IdP redirect (e.g. seamless SSO). Log as status:error so it's visible
        // in monitoring (logger.error → DdLogs.error; logDdError would only emit a RUM error).
        logger.error(`Auth error redirect on deeplink init: ${authError}`)
        emmiter(END)
        return
      }

      if (err) {
        emmiter({ error: err })
      } else {
        emmiter({ params: data?.data_parsed })
      }

      emmiter(END)
    }, 0)
  })

  // Web events don't keep firing, no unsubscribe needed
  return () => {}
}

// Stub method. Web shouldn't ever actually call this right now
export const openUrl = () => {}

export default BranchEventChannel
